/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaTrash: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="trash" viewBox="0 0 14 16">
      <path
        d="M10.3333 3.33334H13C13.368 3.33334 13.6666 3.632 13.6666 4C13.6666 4.368 13.368 4.66667 13 4.66667H12.3333V13.3333C12.3333 14.438 11.438 15.3333 10.3333 15.3333H3.66665C2.56198 15.3333 1.66665 14.438 1.66665 13.3333V4.66667H0.99998C0.63198 4.66667 0.333313 4.368 0.333313 4C0.333313 3.632 0.63198 3.33334 0.99998 3.33334H3.66665V2.66667C3.66665 1.56201 4.56198 0.666672 5.66665 0.666672H8.33331C9.43798 0.666672 10.3333 1.56201 10.3333 2.66667V3.33334ZM8.99998 3.33334V2.66667C8.99998 2.29867 8.70131 2.00001 8.33331 2.00001H5.66665C5.29865 2.00001 4.99998 2.29867 4.99998 2.66667V3.33334H8.99998ZM11 4.66667H2.99998V13.3333C2.99998 13.7013 3.29865 14 3.66665 14H10.3333C10.7013 14 11 13.7013 11 13.3333V4.66667ZM4.99998 7.33334C4.99998 6.96534 5.29865 6.66667 5.66665 6.66667C6.03465 6.66667 6.33331 6.96534 6.33331 7.33334V11.3333C6.33331 11.7013 6.03465 12 5.66665 12C5.29865 12 4.99998 11.7013 4.99998 11.3333V7.33334ZM7.66665 7.33334C7.66665 6.96534 7.96531 6.66667 8.33331 6.66667C8.70131 6.66667 8.99998 6.96534 8.99998 7.33334V11.3333C8.99998 11.7013 8.70131 12 8.33331 12C7.96531 12 7.66665 11.7013 7.66665 11.3333V7.33334Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaTrash)
